import React from 'react'
import { Color } from '../../Common/Color'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import PublicHeaderXS from './PublicHeaderXS'
import PublicHeaderXL from './PublicHeaderXL'

const PHONE_NUMBER = '04 48 24 01 28'
const PHONE_HREF = 'tel:+33448240128'

const styles = {
  header: {
    gap: '10px',
    display: 'flex',
    padding: '1.5em',
    backgroundColor: Color.white,
    color: Color.dark_blue,
    height: '15%',
    alignItems: 'center',
    marginTop: '1em',
    justifyContent: 'space-around'
  },
  logo: {
    cursor: 'pointer',
    marginRight: '1em'
  },
  boxText: {
    width: '20em',
    lineHeight: '17px',
    fontSize: '1.1em',
    display: 'flex'
  },
  search: {
    paddingLeft: '1em',
    display: 'flex'
  },
  largeAssistanceText: {
    lineHeight: '1em',
    textAlign: 'center',
    color: Color.green,
    fontSize: '2em',
    fontWeight: 'bold',
    marginLeft: '1em',
    width: '8em'
  },
  smallAssistanceText: {
    lineHeight: '1em',
    textAlign: 'center',
    color: Color.green,
    fontSize: '1em',
    fontWeight: 'bold',
    marginLeft: '1em'
  },
  assistancePhone: {
    fontSize: '0.7em',
    padding: '0.5em 1em',
    lineHeight: '1em',
    backgroundColor: Color.green,
    color: Color.white,
    borderRadius: '1em'
  },
  menu: {
    '--hover-color': Color.primary,
    '--hover-border-color': Color.primary,
    border: 'solid 2px',
    fontSize: '1.5em',
    borderRadius: '1.5em',
    padding: '0 0.8em 5px 0.8em'
  }
}

export default function PublicHeader ({ withSearch = false }) {
  const screens = useBreakpoint()

  return (
    <>
      {screens.xs && <PublicHeaderXS styles={styles} phoneNumber={PHONE_NUMBER} phoneHref={PHONE_HREF} />}
      {!screens.xs && <PublicHeaderXL withSearch={withSearch} styles={styles} phoneNumber={PHONE_NUMBER} phoneHref={PHONE_HREF} />}
    </>
  )
}
